import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useLanguageStore = defineStore('language', () => {
  // 默认语言为中文
  const currentLanguage = ref<'zh' | 'en'>('zh');

  /**
   * 切换语言
   * @param lang 语言代码 'zh' 或 'en'
   */
  function setLanguage(lang: 'zh' | 'en') {
    currentLanguage.value = lang;
    // 保存到 localStorage
    localStorage.setItem('language', lang);
  }

  /**
   * 初始化语言设置
   */
  function initLanguage() {
    const savedLanguage = localStorage.getItem('language');
    if (savedLanguage === 'zh' || savedLanguage === 'en') {
      currentLanguage.value = savedLanguage;
    }
  }

  return {
    currentLanguage,
    setLanguage,
    initLanguage
  };
});